module.exports = __webpack_public_path__ + "assets/media/day37.ff2e8beb.mp3";